"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkout = checkout;
exports.default = void 0;
exports.getCheckoutPayload = getCheckoutPayload;
exports.handleOnCheckoutActions = handleOnCheckoutActions;
exports.watchCheckout = watchCheckout;
var _recommendationSaga = require("./recommendation/recommendationSaga");
var _questionnaireSaga = require("./questionnaire/questionnaireSaga");
var _userSaga = require("./user/userSaga");
var _productCatalogSaga = require("./productCatalog/productCatalogSaga");
var _taggingEventsSaga = _interopRequireDefault(require("./taggingEventsSaga"));
var _effects = require("redux-saga/effects");
var _constants = require("../utils/constants");
var _services = require("../services");
var _errorSelectors = require("./error/errorSelectors");
var _errorActions = require("./error/errorActions");
var _appActions = require("./appActions");
var _uiActions = require("./ui/uiActions");
var _shareRecommendationSaga = require("./shareRecommendation/shareRecommendationSaga");
var _recommendationSelectors = require("./recommendation/recommendationSelectors");
var _questionnaireSelectors = require("./questionnaire/questionnaireSelectors");
var _logger = require("../services/logger");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function handleOnCheckoutActions() {
  let actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let instanceId = arguments.length > 1 ? arguments[1] : undefined;
  return function* () {
    if (actions.closeModal) yield (0, _effects.put)({
      type: _uiActions.CLOSE_GUIDED_SELLING_MODAL,
      instanceId: instanceId
    });
  }();
}
function* getCheckoutPayload(data, instanceId) {
  const metadata = yield (0, _effects.select)((0, _questionnaireSelectors.selectMetadata)(instanceId));
  const costs = yield (0, _effects.select)((0, _recommendationSelectors.selectPricesCosts)(instanceId));
  const payload = {
    ...data,
    costs,
    appMetadata: metadata
  };
  if (data.planProductId) {
    payload.planProduct = yield (0, _effects.select)((0, _recommendationSelectors.selectSelectedPlan)(instanceId));
    const additionalPlans = yield (0, _effects.select)((0, _recommendationSelectors.selectAdditionalPlans)(instanceId));
    payload.planProduct.additionalPlans = additionalPlans !== null && additionalPlans !== void 0 ? additionalPlans : 0;
  }
  if (data.handsetProductId) {
    var _payload$handsetProdu, _payload$handsetProdu2, _payload$handsetProdu3, _detailsLinkCharacter, _detailsLinkCharacter2, _detailsLinkCharacter3, _detailsLinkCharacter4;
    payload.handsetProduct = yield (0, _effects.select)((0, _recommendationSelectors.selectSelectedHandset)(instanceId));
    const detailsLinkCharacteristic = (_payload$handsetProdu = payload.handsetProduct) === null || _payload$handsetProdu === void 0 ? void 0 : (_payload$handsetProdu2 = _payload$handsetProdu.selectedVariant) === null || _payload$handsetProdu2 === void 0 ? void 0 : (_payload$handsetProdu3 = _payload$handsetProdu2.characteristics) === null || _payload$handsetProdu3 === void 0 ? void 0 : _payload$handsetProdu3.find(char => char.id === 'detailsLink');
    const detailsLinkValue = (detailsLinkCharacteristic === null || detailsLinkCharacteristic === void 0 ? void 0 : (_detailsLinkCharacter = detailsLinkCharacteristic.value) === null || _detailsLinkCharacter === void 0 ? void 0 : _detailsLinkCharacter.length) > 1 ? detailsLinkCharacteristic === null || detailsLinkCharacteristic === void 0 ? void 0 : (_detailsLinkCharacter2 = detailsLinkCharacteristic.value) === null || _detailsLinkCharacter2 === void 0 ? void 0 : (_detailsLinkCharacter3 = _detailsLinkCharacter2.filter(char => char.isDefault === true)[0]) === null || _detailsLinkCharacter3 === void 0 ? void 0 : _detailsLinkCharacter3.value : detailsLinkCharacteristic === null || detailsLinkCharacteristic === void 0 ? void 0 : (_detailsLinkCharacter4 = detailsLinkCharacteristic.value[0]) === null || _detailsLinkCharacter4 === void 0 ? void 0 : _detailsLinkCharacter4.value;
    payload.handsetProductUrl = detailsLinkValue;
  }
  return payload;
}
function* checkout(action) {
  // save user state before checkout

  try {
    yield (0, _effects.put)({
      ...(0, _uiActions.updateTimestamp)([{
        id: 't',
        description: 'termination-basket-success',
        time: new Date(Date.now())
      }]),
      instanceId: action.instanceId
    });
    yield (0, _effects.call)(_userSaga.updateUserSessionApiCall, _constants.RECOMMENDATION_PAGE_INDEX, action.instanceId);
  } catch (e) {
    _logger.Logger.error({
      segments: [_logger.Logger.LOGGER_SEGMENTS.SAGAS]
    })(e);
  }
  const isAddonSelected = yield (0, _effects.select)((0, _recommendationSelectors.selectIsAddonSelected)(action.instanceId));
  try {
    const {
      handsetProductId,
      planProductId,
      upsoldProductIds,
      broadbandProductId,
      businessSolutionId,
      businessSolutionUrl
    } = action.payload;
    const body = (upsoldProductIds === null || upsoldProductIds === void 0 ? void 0 : upsoldProductIds.length) > 0 ? {
      handsetProductId,
      planProductId,
      upsoldProductIds,
      broadbandProductId
    } : {
      handsetProductId,
      planProductId,
      broadbandProductId,
      businessSolutionId: isAddonSelected ? businessSolutionId : businessSolutionId.split('_')[0],
      businessSolutionUrl
    };
    const actions = yield (0, _effects.call)(_services.Services.host.addToCart, yield getCheckoutPayload(body, action.instanceId));
    yield (0, _effects.put)({
      type: _appActions.CHECKOUT_SUCCESS,
      instanceId: action.instanceId,
      productIds: action.payload
    });
    if (actions) yield handleOnCheckoutActions(actions, action.instanceId);
  } catch (e) {
    _logger.Logger.error({
      segments: [_logger.Logger.LOGGER_SEGMENTS.SAGAS]
    })(e);
    const currentPage = yield (0, _effects.select)((0, _errorSelectors.selectCurrentPage)(action.instanceId));
    yield (0, _effects.put)({
      type: _appActions.CHECKOUT_ERROR,
      instanceId: action.instanceId
    });
    yield (0, _effects.put)({
      ...(0, _uiActions.updateTimestamp)([{
        id: 't-ko',
        description: 'termination-basket-failure',
        time: new Date(Date.now())
      }]),
      instanceId: action.instanceId
    });
    yield (0, _effects.put)({
      ...(0, _errorActions.setApiCallError)({
        actionToRetry: action,
        pageToReturnTo: currentPage
      }),
      instanceId: action.instanceId
    });
  }
}
function* watchCheckout() {
  yield (0, _effects.takeEvery)(_appActions.CHECKOUT, checkout);
}
const watchers = [(0, _questionnaireSaga.watchQuestionnaire)(), (0, _recommendationSaga.watchRecommendation)(), (0, _userSaga.watchUserSession)(), (0, _productCatalogSaga.watchProductCatalog)(), watchCheckout(), (0, _productCatalogSaga.watchProductRelationshipOfferings)(), (0, _shareRecommendationSaga.watchSendRecommendation)(), (0, _shareRecommendationSaga.watchSaveUserSessionSuccess)(), ..._taggingEventsSaga.default];
var _default = watchers;
exports.default = _default;